import React from 'react'
import PropTypes from 'prop-types'

const deviceSVG = ({ color, width, height }) => (
    <svg viewBox="0 0 24 24" width={width} height={height}>
        <g>
            <path
                d=" M 20.2 5.9 L 21 5.1 C 19.6 3.7 17.8 3 16 3 C 14.2 3 12.4 3.7 11 5.1 L 11.8 5.9 C 13 4.8 14.5 4.2 16 4.2 C 17.5 4.2 19 4.8 20.2 5.9 Z  M 19.3 6.7 C 18.4 5.8 17.2 5.3 16 5.3 C 14.8 5.3 13.6 5.8 12.7 6.7 L 13.5 7.5 C 14.2 6.8 15.1 6.5 16 6.5 C 16.9 6.5 17.8 6.8 18.5 7.5 L 19.3 6.7 L 19.3 6.7 Z  M 19 13 L 17 13 L 17 9 L 15 9 L 15 13 L 5 13 C 3.9 13 3 13.9 3 15 L 3 19 C 3 20.1 3.9 21 5 21 L 19 21 C 20.1 21 21 20.1 21 19 L 21 15 C 21 13.9 20.1 13 19 13 Z  M 8 18 L 6 18 L 6 16 L 8 16 L 8 18 L 8 18 Z  M 11.5 18 L 9.5 18 L 9.5 16 L 11.5 16 L 11.5 18 L 11.5 18 Z  M 15 18 L 13 18 L 13 16 L 15 16 L 15 18 L 15 18 Z "
                fill={color}/>
        </g>
    </svg>
)

deviceSVG.defaultProps = {
    color: '#fff',
    width: 24,
    height: 24,
}

deviceSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default (deviceSVG)
